module.exports = __webpack_public_path__ + "img/blueberry.853e75e1.png";